import { getTasklistInstance } from '../api/getTasklistByInstanceId';
import { poll, type PollOptions } from './poll';

export const pollFeedbackStatus = (
  tasklistId: string,
  responseId: string,
  matcher: (status: string) => boolean,
  pollOptions: Partial<PollOptions> = {}
) => {
  return poll(() => {
    return getTasklistInstance(tasklistId, true).then(tasklist => {
      if (!tasklist) {
        return Promise.reject(new Error('Tasklist not found for id: ' + tasklistId));
      }

      const feedbackTask = tasklist.tasks.find(task => task.task?._type === 'Feedback');
      if (!feedbackTask || !feedbackTask.task) {
        return Promise.reject(new Error('Feedback task not found'));
      }

      if (!('feedbackResponses' in feedbackTask.task && Array.isArray(feedbackTask.task.feedbackResponses))) {
        return Promise.reject(new Error('No feedback responses found in task'));
      }

      const feedbackResponse = feedbackTask.task.feedbackResponses.find(
        (response: { responseId: string }) => response.responseId === responseId
      );

      if (!feedbackResponse) {
        return Promise.reject(new Error('Feedback response not found with responseId: ' + responseId));
      }

      if (matcher(feedbackResponse.status)) {
        return feedbackResponse;
      } else {
        return Promise.reject(new Error('Feedback response status did not match'));
      }
    });
  }, pollOptions);
};
